<template>
    <!-- user-info-view .civ -->
    <div class="civ">
        <div class="header-tool">
            <div class="header-tool-info">
                <Breadcrumb>
                    <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
                    <BreadcrumbItem>供需信息</BreadcrumbItem>
                    <BreadcrumbItem>招商供需信息</BreadcrumbItem>
                </Breadcrumb>
                <div class="header-tool-title">供需信息</div>
            </div>
            <div class="header-tool-box">
                <div class="htb-item" @click="excelDown()">
                    <i class="icon iconfont icon-downLoad2"></i>
                    <span>导出明细</span>
                </div>
            </div>
        </div>
        <!-- <div class="header-switch">
      <div class="header-switch-text">记录所有企业供需信息</div>
      <div class="header-switch-box">
        <RadioGroup v-model="allDone" type="button" @on-change="changeRadio">
          <Radio label="待处理"></Radio>
          <Radio label="已处理"></Radio>
        </RadioGroup>
      </div>
    </div> -->
        <div class="header-tabs">
            <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
                <TabPane :label="item.name" :name="item.name" v-for="(item, index) in listTab" :key="index">
                    <supplyCompanyInfoAll v-if="item.name == showTabs" :status="handleStatus" />
                </TabPane>
                <!-- <TabPane :label="item.name" :name="item.id" v-for="(item, index) in list2" :key="item.id">
          <supplyCompanyInfoCheck :releaseType="item.id" v-if="showTabs === item.id" :status="handleStatus" />
        </TabPane> -->
            </Tabs>
        </div>
    </div>
</template>

<script>
import supplyCompanyInfoAll from "./subpages/supply-company-info-all-new.vue";
import supplyCompanyInfoCheck from "./subpages/supply-company-info-check-new.vue";
import { mapActions } from "vuex";

export default {
    name: "host-supply-company-info",
    data () {
        return {
            list2: [],
            showTabs: "全部",
            text: "",
            show: false,
            allDone: "待处理",
            handleStatus: "0", // 0：Submited=已提交  1： Audited=已审核


            listTab: [
                {
                    name: "全部",
                },
                {
                    name: "待审核",
                },
                {
                    name: "审核通过",
                },
            ],
        };
    },
    computed: {
        option () {
            return {
                // ExhibitionId: this.exhibitionInfo.id,
                PageSize: 99999,
                PageIndex: 1,
                isSearchAll: false,
                Wheres: {
                    type: 0,
                    wheres: {
                        WhereGroupOperator: 0,
                        Predicates: [
                            {
                                type: 1,
                                wheres: {
                                    WhereOperator: 0,
                                    Label: 'PublishType',
                                    Value: '招商发布',
                                },
                            },
                            {
                                type: 1,
                                wheres: {
                                    WhereOperator: 6,
                                    Label: 'name',
                                    Value: `%${this.text}%`,
                                },
                            },
                        ],
                    },
                },
            };
        },
        exhibitionInfo () {
            if (JSON.parse(localStorage.vuex)) {
                return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
            }
        }
    },
    components: {
        supplyCompanyInfoCheck,
        supplyCompanyInfoAll
    },
    async created () {
        // let listData = await this.getReleaseType(this.exhibitionInfo.id);
        this.showTabs = "全部";
        this.$router.push(`${this.$route.path}?type=全部`);
        // if (listData && listData.length) {
        //   this.list2 = listData;
        // }
        // this.changeTab();
    },
    methods: {
        ...mapActions({
            getReleaseType: "momentModule/getReleaseType",
            postExcelExportZhaoShang: "releaseModule/postExcelExportZhaoShang",
        }),

        async excelDown () {
            let res = await this.postExcelExportZhaoShang(this.option);
            let filename = "招商供需信息导出.xlsx";
            const blob = new Blob([res]); // 构造一个blob对象来处理数据，并设置文件类型
            if (window.navigator.msSaveOrOpenBlob) {
                // 兼容IE10
                navigator.msSaveBlob(blob, filename);
            } else {
                const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
                const a = document.createElement("a");
                a.style.display = "none";
                a.href = href; // 指定下载链接
                a.download = filename; // 指定下载文件名
                a.click();
                URL.revokeObjectURL(a.href); // 释放URL对象
            }
            this.$Message.success("导出成功，耐心等待");
        },


        switchBrand (name) {
            if (name) {
                this.$router.push(`${this.$route.path}?type=${name}`);
                this.handleStatus = "0";
                this.allDone = "待处理";
            }
        },
        showAdd (name) {
            this.$refs[name].showAdd();
        },
        changeRadio (e) {
            if (e === "待处理") {
                this.handleStatus = "0";
            } else if (e === "已处理") {
                this.handleStatus = "1";
            }
            console.log(this.handleStatus);
        }
    }
};
</script>

<style scoped lang="scss">
.header-switch {
    display: flex;
    align-items: center;
    padding: 0 35px 18px 35px;
    background: #fff;

    &-text {
        flex: 1;

        font-size: 14px;
        color: #808080;
    }

    &-box {
        flex: 1;
        text-align: right;
    }
}
</style>
